import {
  Text,
  TextFontSizes,
  TextFontWeights,
  TextLineHeights,
  Youtube,
} from '@cinch-labs/design-system'
import { FinanceExplainedText } from '../../types/locales'
import styles from './finance-explained.module.css'
import { Wrapper } from '@cinch-nx/shared-ui'
import youtubeCoverImage from './assets/ways-to-buy.jpeg'

interface FinanceExplainedProps {
  i18n: FinanceExplainedText
}

function FinanceExplained({ i18n }: FinanceExplainedProps) {
  return (
    <Wrapper>
      <article className={styles.youtubeWrapper}>
        <Text
          element="h2"
          className={styles.youtubeWrapperTitle}
          fontSize={TextFontSizes['3xl']}
          fontWeight={TextFontWeights.bold}
          lineHeight={TextLineHeights.display}
        >
          {i18n.sectionTitle}
        </Text>
        <Youtube
          videoId="rHYjjHiJcro"
          title={i18n.videoTitle}
          customThumbnail={youtubeCoverImage.src}
          buttonLabel={`${i18n.cta.start} ${i18n.videoTitle} ${i18n.cta.end}`}
          showNewPlayIcon
        />
      </article>
    </Wrapper>
  )
}

export default FinanceExplained
